export default "__VITE_ASSET__CFjSEmsg__"